import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const FolderMathIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M9.17 6L11.17 8H20V18H4V6H9.17ZM10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z"
            fill="#222"
          />
          <path stroke="#222" d="M12 7L4 7" strokeWidth="2" />
          <path
            d="M16.5 12H14V11H16.5V12zM10.5 11.5923H8V10.9995H10.5V11.5923zM15.7287 16.2159L14 14.4099 14.4282 14 16.157 15.8059 15.7287 16.2159z"
            fill="#222"
          />
          <path
            d="M9.59282 9.99979V12.4995H9V9.99979H9.59282zM16.2519 14.4594L14.4462 16.188 14.0363 15.7598 15.842 14.0312 16.2519 14.4594zM10.3333 14.5928H8V14H10.3333V14.5928zM10.3333 15.5928H8V15H10.3333V15.5928z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
